import { render, staticRenderFns } from "./GoodsVideoShoot.vue?vue&type=template&id=e3176494&scoped=true&"
import script from "./GoodsVideoShoot.vue?vue&type=script&lang=js&"
export * from "./GoodsVideoShoot.vue?vue&type=script&lang=js&"
import style0 from "./GoodsVideoShoot.vue?vue&type=style&index=0&id=e3176494&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3176494",
  null
  
)

export default component.exports